import { FILE_LAST_USER, getUserTokenPath, DIR_FILES, getModuleDirPath, getEntityDir, DIR_IMAGES, getSyncFilePath, getEntityDataPath, getUserDownloadPath, getDownloadPath, getLastDownloadDataFilePath } from '../../consts/filesystem/PATHS.cts';
import { getFilePathFxProps, IGetPathOpts, ILayersPathOpts, IPath, IPathKey } from '../../interfaces/services/filesystem/Paths'

export const PATHS_KEYS: IPath[] = [
  { key: 'last-user', isDirectory: false },
  { key: 'token' , isDirectory: false },
  { key: 'modules', isDirectory: true },
  { key: 'entity' , isDirectory: false },
  { key: 'entity-dir', isDirectory: true },
  { key: 'sync-requests', isDirectory: true },
  { key: 'sync-files', isDirectory: true },
  { key: 'download-status', isDirectory: true },
  { key: 'layers', isDirectory: ( opts?: ILayersPathOpts ) => opts === undefined },
  { key: 'basemap', isDirectory: true },
  { key: 'last-download-data', isDirectory: false }
]

export default function getFilePath (pathData: getFilePathFxProps): string {
  // Estas 2 lineas deberian ser eliminadas.
  // No aceptar key last-user, usar filename.
  // userId cambia a uid
  if ((pathData as any).key === 'last-user') { return FILE_LAST_USER }
  // if ('userId' in pathData) { (pathData as any).uid = pathData.userId }

  if ('uid' in pathData) {
    if (pathData.key === 'token') {
      return getUserTokenPath(pathData.uid)
    }
    return getEntityDir(pathData.uid)
  }

  if ('filename' in pathData) {
    if (pathData.filename === 'last-user') {
      return FILE_LAST_USER
    }
    if (pathData.filename === 'layers') {
      return DIR_IMAGES
    }
    return `${DIR_FILES}/${pathData.filename}`
  }
  return getModuleDirPath(pathData.module)
}

export function getFilePath2( key: IPathKey, userId?: number, opts?: IGetPathOpts ): string {

  if (key === 'last-user') {
    return FILE_LAST_USER
  }

  if ( userId !== undefined ){
    if (key === 'token') {
      return getUserTokenPath(userId)
    }
    if (key === 'entity' && opts?.entity_name !== undefined){
      return getEntityDataPath(userId, opts.entity_name, opts.entity_uuid)
    }
    if (key === 'layers' && opts?.image){
      return getDownloadPath(userId, key, opts)
    }
    if (key === 'last-download-data'){
      return getLastDownloadDataFilePath(userId)
    }
  }

  throw new Error("Path not found");

}

export function getDirPath( key: IPathKey, userId?: number, opts?: IGetPathOpts ): string {

  let path;
  if (key === 'modules'){
    path = getModuleDirPath(opts?.mfe_id, opts?.mfe_version)
  } else if ( userId !== undefined ){
    if (key === 'sync-requests'){
      path = getSyncFilePath(userId, 'requests')
    }
    if (key === 'sync-files'){
      path = getSyncFilePath(userId, 'files')
    }
    if (key === 'entity-dir'){
      path = getEntityDir(userId)
    }
    if (key === 'download-status'){
      path = getUserDownloadPath(userId, opts?.filename)
    }
    if (key === 'basemap'){
      path = getDownloadPath(userId, 'basemap')
    }
    if (key === 'layers'){
      path = getDownloadPath(userId, 'layers')
    }
  }

  if ( path !== undefined ){

    if ( opts?.filename !== undefined ){
      path += `/${ opts.filename }`
    }
    
    return path
  }

  throw new Error("Path not found");

}